import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const ContactContainer = styled(Box)(({ theme }) => ({
    backgroundColor: '#1a2e4a',
    borderRadius: theme.spacing(1.5),
    padding: theme.spacing(5, 3),
    [theme.breakpoints.down('md')]: {
        padding: theme.spacing(4, 2),
    },
}));

const ContactRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        gap: theme.spacing(1.5),
    },
}));

const ContactItem = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
}));

const IconWrapper = styled(Box)(({ theme }) => ({
    color: theme.palette.orange?.main || '#e67e22',
    display: 'flex',
    alignItems: 'center',
}));

const ContactQuestionsSection: React.FC = () => {
    return (
        <ContactContainer>
            <Typography 
                variant="h3" 
                align="center" 
                gutterBottom
                sx={{ 
                    mb: 3,
                    fontSize: { xs: '1.5rem', sm: '1.75rem' },
                    color: '#ffffff',
                }}
            >
                Questions? We're Here to Help
            </Typography>

            <ContactRow>
                <ContactItem>
                    <IconWrapper>
                        <PhoneIcon />
                    </IconWrapper>
                    <Typography variant="body1" sx={{ fontSize: '1rem', color: '#ffffff' }}>
                        <strong>Daron:</strong>{' '}
                        <a 
                            href="tel:360-903-7268" 
                            style={{ 
                                color: '#ffffff', 
                                textDecoration: 'none',
                            }}
                        >
                            360-903-7268
                        </a>
                    </Typography>
                </ContactItem>

                <ContactItem>
                    <IconWrapper>
                        <PhoneIcon />
                    </IconWrapper>
                    <Typography variant="body1" sx={{ fontSize: '1rem', color: '#ffffff' }}>
                        <strong>Chip:</strong>{' '}
                        <a
                            href="tel:619-663-9330"
                            style={{
                                color: '#ffffff',
                                textDecoration: 'none',
                            }}
                        >
                            619-663-9330
                        </a>
                    </Typography>
                </ContactItem>
            </ContactRow>

            <ContactRow>
                <ContactItem>
                    <IconWrapper>
                        <EmailIcon />
                    </IconWrapper>
                    <Typography variant="body1" sx={{ fontSize: '1rem', color: '#ffffff' }}>
                        <a 
                            href="mailto:crew@pointsails.com"
                            style={{ 
                                color: '#ffffff', 
                                textDecoration: 'none',
                            }}
                        >
                            crew@pointsails.com
                        </a>
                    </Typography>
                </ContactItem>
            </ContactRow>

            <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                gap: 1,
                mt: 3,
                pt: 2,
                borderTop: '1px solid rgba(255,255,255,0.2)'
            }}>
                <IconWrapper>
                    <AccessTimeIcon fontSize="small" />
                </IconWrapper>
                <Typography 
                    variant="body2" 
                    sx={{ 
                        fontSize: '0.938rem',
                        color: 'rgba(255,255,255,0.8)',
                        fontStyle: 'italic'
                    }}
                >
                    Typical delivery: 5–7 weeks from order
                </Typography>
            </Box>
        </ContactContainer>
    );
};

export default ContactQuestionsSection;
